module.exports = __webpack_public_path__ + "img/vertical_6_3_7016.a96c13b9.png";